import { usePageConfiguration } from ".";

export const useActiveTab = () => {
  const { activeTab, setActiveTab } = usePageConfiguration();

  return {
    activeTab,
    isBreakdownTab: activeTab === "breakdown",
    isCampaignTab: activeTab === "campaign",
    setActiveTab,
  } as const;
};
